import React from 'react'

import NavButton from './navButton'
import IconNext from '../../icons/chevronRight'

import styles from './buttons.module.css'

const NextButton = ({ item }) => (
  <NavButton keyName="ArrowRight" item={item}>
    <IconNext className={styles.iconNext} />
  </NavButton>
)

export default NextButton
